/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LabelCalculatedYearlyConsumptionDto { 
    value: number;
    source: LabelCalculatedYearlyConsumptionDto.SourceEnum;
}
export namespace LabelCalculatedYearlyConsumptionDto {
    export type SourceEnum = 'MANUAL' | 'MONTHLY_SUM';
    export const SourceEnum = {
        Manual: 'MANUAL' as SourceEnum,
        MonthlySum: 'MONTHLY_SUM' as SourceEnum
    };
}


